import React, { useCallback, useMemo } from 'react';
import styles from '@/common/containers/Modals/UserGuide/styles.less';
import { useStepperContext } from '@/common/hooks/index';
import { StepperProvider } from '@/common/components/Stepper/index';
import Button from '@mui/material/Button';
import cx from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import CopyrightSup from '@/common/components/CopyrightSup';
import useLocale from '@/common/hooks/useLocale';

import image1 from '@/common/assets/guide/1.png';
import image2 from '@/common/assets/guide/2.png';
import image3 from '@/common/assets/guide/3.png';
import image4 from '@/common/assets/guide/4.png';
import imageFr1 from '@/common/assets/guideFr/1.png';
import imageFr2 from '@/common/assets/guideFr/2.png';
import imageFr3 from '@/common/assets/guideFr/3.png';
import imageFr4 from '@/common/assets/guideFr/4.png';

const IMAGES = [image1, image2, image3, image4];
const IMAGES_FR = [imageFr1, imageFr2, imageFr3, imageFr4];

const STEPS = ['first', 'second', 'third', 'fourth'];

const OverviewBody = ({ onClose }) => {
  const { nextStep, prevStep, currentStepInd } = useStepperContext();
  const { t } = useTranslation();
  const { isFr } = useLocale();
  const copyrightSup = <CopyrightSup />;

  const textList = useMemo(
    () => [
      <Trans
        i18nKey="<1>Task list</1> is your main workspace. Here you will find the action you need to perform at particular moment of time."
        components={{ 1: <b /> }}
      />,
      <Trans
        i18nKey="In the <1>Decedent’s profile</1> view you can access and edit all of the personal information related to the decedent."
        components={{ 1: <b /> }}
      />,
      <Trans
        i18nKey="After completing the questionnaire for each module, the associated <1>Task list module</1> becomes available. You will be able to navigate between modules using the tabs at the top."
        components={{ 1: <b /> }}
      />,
      t(
        'You can reach the general decedent information any time by clicking this button.'
      ),
    ],
    [t]
  );

  const stepData = useMemo(() => {
    const images = isFr ? IMAGES_FR : IMAGES;

    return {
      text: textList[currentStepInd],
      img: images[currentStepInd],
    };
  }, [currentStepInd, isFr, textList]);

  return (
    <>
      <div className={styles.modalHeader}>
        <h3>
          <Trans
            i18nKey="PAEM After Care<copyrightSup/> overview"
            components={{ copyrightSup }}
          />
        </h3>
      </div>
      <div className={cx(styles.modalBody, styles.overview)}>
        <p className={styles.overviewText}>{stepData.text}</p>
        <img className={styles.overviewImg} src={stepData.img} />
      </div>
      <div className={styles.modalFooter}>
        {currentStepInd > 0 && (
          <Button variant="outlined" color="secondary" onClick={prevStep}>
            {t('Back')}
          </Button>
        )}
        <div className={styles.modalFooterBtns}>
          <Button variant="outlined" color="secondary" onClick={onClose}>
            {t('Close')}
          </Button>
          <Button
            variant="contained"
            type="success"
            onClick={currentStepInd === STEPS.length - 1 ? onClose : nextStep}
          >
            {currentStepInd === STEPS.length - 1 ? t('Get started') : t('Next')}
          </Button>
        </div>
      </div>
    </>
  );
};

const Overview = (props) => {
  return (
    <StepperProvider steps={STEPS}>
      <OverviewBody {...props} />
    </StepperProvider>
  );
};

export default Overview;
